package app.nestbridge.domain.ping.service

import app.nestbridge.domain.ping.model.HttpBinHeadersResponse

internal fun Map<String, String>.toDomain(): HttpBinHeadersResponse =
    HttpBinHeadersResponse(headers = this)
